import { ReactElement, memo } from 'react'
import { Navigate, PathRouteProps } from 'react-router-dom'

import { useAuthContext } from '@modules/auth/hooks/useAuthContext'

interface SubscriptionRouteProps extends PathRouteProps {
  accessibleLevels: number[]
  children: ReactElement
}

const SubscriptionRoute = ({ accessibleLevels, children }: SubscriptionRouteProps) => {
  const { user } = useAuthContext()

  const hasAccess = accessibleLevels?.includes(user?.subscriptionLevel ?? -1)

  if (hasAccess) {
    return children
  }

  return user ? <Navigate replace to="/plus/hub" /> : null
}

export default memo(SubscriptionRoute)
